import Vue from 'vue'
import Router from 'vue-router'
import VueCookies from 'vue-cookies'
import axios from 'axios'
import applyAppTokenRefreshInterceptor from '@/config/Interceptor';
import HomePage from '@/views/HomePage'
import Products from '@/views/Products'
import ProductDetail from '@/views/ProductDetail'
import Cart from '@/views/Cart'
import Payment from '@/views/Payment'
import PurchaseMade from '@/views/PurchaseMade'
import OrderTrackingLogin from '@/views/OrderTrackingLogin'
import OrderTrackingDetail from '@/views/OrderTrackingDetail'
import Conditions from '@/views/Conditions'
import PrivacyPolicy from '@/views/PrivacyPolicy'
import CartStore from '@/stores/Cart'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'HomePage',
      component: HomePage,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/products',
      name: 'Products',
      component: Products,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/product-detail/:productColorId/:productId/:productName',
      name: 'ProductDetail',
      component: ProductDetail,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/checkout/cart',
      name: 'Cart',
      component: Cart,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/checkout/payment',
      name: 'Payment',
      component: Payment,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/checkout/purchase-made/:orderNumber',
      name: 'PurchaseMade',
      component: PurchaseMade,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/track/guest/order',
      name: 'OrderTrackingLogin',
      component: OrderTrackingLogin,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/track/guest/order/detail',
      name: 'OrderTrackingDetail',
      component: OrderTrackingDetail,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/conditions',
      name: 'Conditions',
      component: Conditions,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/privacy-policy',
      name: 'PrivacyPolicy',
      component: PrivacyPolicy,
      meta: {
        requiresAuth: true
      }
    }
  ],
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
})

axios.defaults.baseURL = process.env.DINO.ENDPOINT;
axios.interceptors.request.use(config => {
  const token = VueCookies.get("token");
  const xKey = VueCookies.get("key")
  config.headers['x-key'] = xKey;

  if (token) {
    config.headers['authorization'] = token;
  }
  return config;
}, error => {
  Promise.reject(error)
});

applyAppTokenRefreshInterceptor(axios);

router.beforeEach((to, from, next) => {
  CartStore.dispatch('getCartQuantity');
  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js